document.addEventListener("DOMContentLoaded", function () {
  if ($('#garages-pagination').length > 0) {
    let options = {
      valueNames: [ 'distance', 'price' ],
      page: 5,
      pagination: true
    };

    let garagesList = new List('garages-pagination', options);

    garagesList.sort(
      'distance',
      {
        order: 'asc'
      }
    );

    $('select#filter-by').on('change', function () {
      let val = $(this).val();

      if (val === 'distance-asc') {
        garagesList.sort(
          'distance',
          {
            order: 'asc'
          }
        );
      }

      if (val === 'price-asc') {
        garagesList.sort(
          'price',
          {
            order: 'asc'
          }
        );
      }

      if (val === 'distance-desc') {
        garagesList.sort(
          'distance',
          {
            order: 'desc'
          }
        );
      }

      if (val === 'price-desc') {
        garagesList.sort(
          'price',
          {
            order: 'desc'
          }
        );
      }
    });
  }

  if ($('#posts-list').length > 0) {
    let options = {
      valueNames: [ 'category1', 'category2', 'category3', 'category4', 'category5', 'title' ],
      page: 4,
      pagination: true,
      listClass: 'cards-actus'
    };

    let postsList = new List('posts-list', options);

    $('span.cat-filter-all').on('click',function() {
      $('h3.cat-filter').removeClass('active');
      postsList.filter();
    });

    $('h3.cat-filter').on('click',function() {
      let $text = $(this).text();
      $('h3.cat-filter').removeClass('active');
      postsList.filter(function(item) {
        return (item.values().category1 == $text || item.values().category2 == $text || item.values().category3 == $text || item.values().category4 == $text || item.values().category5 == $text);
      });
      $(this).addClass('active');
    });
  }
});
